/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InstallmentStatus {
    FAILED = 'failed',
    UNPAID = 'unpaid',
    PAID = 'paid',
    PENDING = 'pending',
    SCHEDULED = 'scheduled',
    CANCELED = 'canceled',
    REFUNDED = 'refunded',
    PARTIALLY_REFUNDED = 'partially_refunded',
    DISPUTED = 'disputed',
}
